import { apiClient } from './client';
import type { Order, ApiResponse } from '../types';

export interface CheckoutData {
  shipping_address: {
    house_number: string;
    address_line_1: string;
    address_line_2?: string;
    city_id: number;
    label?: string;
    delivery_note?: string;
  };
  customer_name: string;
  customer_phone: string;
  customer_notes?: string;
  items: Array<{
    product_variant_id: number;
    quantity: number;
    price: number;
  }>;
}

export const checkoutAPI = {
  // Create order from cart
  async createOrder(orderData: any): Promise<ApiResponse<Order>> {
    try {
      const response = await apiClient.post<Order>('/orders/', orderData);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response?.data?.detail || error.response?.data?.message || 'Failed to create order',
        status: error.response?.status || 500,
      };
    }
  },

  // Validate address
  async validateAddress(addressData: any): Promise<ApiResponse<{ valid: boolean; message?: string }>> {
    try {
      const response = await apiClient.post('/core/addresses/validate/', addressData);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response?.data?.detail || 'Failed to validate address',
        status: error.response?.status || 500,
      };
    }
  },
};